import VBtn from './VBtn'

export { VBtn }
export default VBtn



// WEBPACK FOOTER //
// ../../../src/components/VBtn/index.ts